import * as Immutable from "immutable";

const UploadedFileMap = Immutable.OrderedMap;

export default UploadedFileMap;
